module.exports = __webpack_public_path__ + "static/media/DuplicateSans-ThinItalic.603169a0.woff";